import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { usePlatformAuth } from './usePlatformAuth.js';
import { PlatformLoginScreen } from './PlatformLoginScreen.jsx';
import { PlatformChangePassword } from './PlatformChangePassword.jsx';
import { PlatformDashboard } from './PlatformDashboard.jsx';

function Splash() {
  return (
    <div
      className="min-h-screen grid place-items-center"
      style={{ background: 'linear-gradient(135deg, #FF7A1A 0%, #FFB627 60%, #EC4899 110%)' }}
    >
      <div className="card px-6 py-5 text-center">
        <img src="/kidzo-mark.png" alt="Kids Zone" className="w-12 h-12 mx-auto object-contain" />
        <div className="text-[13px] text-ink-2 mt-3">جاري التحقّق من الجلسة...</div>
      </div>
    </div>
  );
}

/** حارس البوابة: لا شيء يُعرض قبل فحص /platform/me. */
function Guard({ children, allowMustChange = false }) {
  const user = usePlatformAuth((s) => s.user);
  const ready = usePlatformAuth((s) => s.ready);

  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/platform/login" replace />;
  if (user.mustChangePassword && !allowMustChange) {
    return <Navigate to="/platform/change-password" replace />;
  }
  return children;
}

/**
 * بوابة مدير النظام — تُركَّب خارج Shell الشركة (standalone) ولها توجيهها الخاص.
 * /platform               → اللوحة (محميّة بحارس البوابة)
 * /platform/login         → تسجيل الدخول
 * /platform/change-password → تغيير كلمة المرور (إجباري عند mustChangePassword)
 */
export function PlatformPortal() {
  const bootstrap = usePlatformAuth((s) => s.bootstrap);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  useEffect(() => {
    const prev = document.title;
    document.title = 'لوحة مدير النظام — Kids Zone';
    return () => { document.title = prev; };
  }, []);

  return (
    <Routes>
      <Route path="login" element={<PlatformLoginScreen />} />
      <Route
        path="change-password"
        element={<Guard allowMustChange><PlatformChangePassword /></Guard>}
      />
      <Route index element={<Guard><PlatformDashboard /></Guard>} />
      <Route path="*" element={<Navigate to="/platform" replace />} />
    </Routes>
  );
}
